import { memoize } from '@sama/micro-dash';
import { OutputType } from '../../team-apis/otterdam/outputs/output';
import { CheckboxOutputHelper } from './checkbox-output-helper';
import { DateOutputHelper } from './date-output-helper';
import { DropdownOutputHelper } from './dropdown-output-helper';
import { ImageOutputHelper } from './image-output-helper';
import { MultilevelMenuOutputHelper } from './multilevel-menu-output-helper';
import { OutputHelper } from './output-helper';
import { PointCloudOutputHelper } from './point-cloud-output-helper';
import { RadioOutputHelper } from './radio-output-helper';
import { TagLibraryOutputHelper } from './tag-library-output-helper';
import { TextAreaOutputHelper } from './text-area-output-helper';
import { TextfieldOutputHelper } from './textfield-output-helper';
import { VideoOutputHelper } from './video-output-helper';

export const getOutputHelper = memoize(
  // eslint-disable-next-line complexity -- we didn't come up with a better alternative
  (outputType: OutputType): OutputHelper => {
    switch (outputType) {
      case 'CheckboxOutput':
        return new CheckboxOutputHelper();
      case 'DateOutput':
        return new DateOutputHelper();
      case 'DropdownOutput':
        return new DropdownOutputHelper();
      case 'ImageAnnotationOutput':
        return new ImageOutputHelper();
      case 'MultilevelMenuOutput':
        return new MultilevelMenuOutputHelper();
      case 'PointCloudOutput':
        return new PointCloudOutputHelper();
      case 'RadioOutput':
        return new RadioOutputHelper();
      case 'TagLibraryOutput':
        return new TagLibraryOutputHelper();
      case 'TextAreaOutput':
        return new TextAreaOutputHelper();
      case 'TextfieldOutput':
        return new TextfieldOutputHelper();
      case 'VideoOutput':
        return new VideoOutputHelper();
      default:
        return new OutputHelper();
    }
  },
);
